import { render, staticRenderFns } from "./Sharers.vue?vue&type=template&id=7c30d2d8"
import script from "./Sharers.vue?vue&type=script&lang=js"
export * from "./Sharers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports